<script>
    import { getSpotsString } from "./../Utils";

    export let institution;
</script>

<p class={`text-xs md:text-base ml-4`}>
    {#if institution.last_spot === "99999"}
        {institution.institution} (vaga sobrante)
    {:else}
        {institution.institution}, {institution.n_spots}
        {getSpotsString(institution.n_spots)} (u.c. {institution.last_grade})
    {/if}
</p>
